<template>
    <div class="m-header">
        <div class="header-inner">
            <router-link to="/blogs" class="brand">
                <img class="brand-logo" src="../assets/logo.png" alt="Logo">
                <span class="brand-name">My Blog</span>
            </router-link>

            <div class="nav-right">
                <template v-if="hasLogin">
                    <el-avatar :size="32" :src="user.avatar" class="user-avatar"></el-avatar>
                    <span class="user-name">{{ user.username }}</span>

                    <el-divider direction="vertical"></el-divider>

                    <router-link to="/knowledge" class="nav-link">
                        <i class="el-icon-chat-dot-round"></i> 知识库
                    </router-link>

                    <router-link to="/knowledge/manage" class="nav-link">
                        <i class="el-icon-document"></i> 文档管理
                    </router-link>

                    <router-link to="/blog/add" class="nav-link">
                        <i class="el-icon-edit-outline"></i> 写文章
                    </router-link>

                    <span class="nav-link logout-link" @click="logout">
                        <i class="el-icon-switch-button"></i> 退出
                    </span>
                </template>

                <template v-else>
                    <router-link to="/login" class="nav-link login-link">
                        登录
                    </router-link>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Header",
        data() {
            return {
                user: {
                    username: '',
                    avatar: '../assets/logo.png'
                }
            }
        },
        computed: {
            hasLogin() {
                const userInfo = this.$store.getters.getUser
                return userInfo && userInfo.username
            }
        },
        watch: {
            hasLogin(val) {
                if (val) {
                    const userInfo = this.$store.getters.getUser
                    this.user.username = userInfo.username
                    this.user.avatar = userInfo.avatar || this.user.avatar
                }
            }
        },
        created() {
            if (this.hasLogin) {
                const userInfo = this.$store.getters.getUser
                this.user.username = userInfo.username
                this.user.avatar = userInfo.avatar || this.user.avatar
            }
        },
        methods: {
        logout() {
            const _this = this
            _this.$axios.post("http://localhost:8888/logout").then(() => {
                _this.$store.commit("REMOVE_INFO")
                _this.$router.push("/login")
            }).catch(() => {
                _this.$store.commit("REMOVE_INFO")
                _this.$router.push("/login")
            })
        }
        }
    }
</script>

<style scoped>
    .m-header {
        background: #fff;
        border-bottom: 1px solid #f0f0f0;
        position: sticky;
        top: 0;
        z-index: 100;
    }

    .header-inner {
        max-width: 960px;
        margin: 0 auto;
        padding: 0 20px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .brand {
        display: flex;
        align-items: center;
        text-decoration: none;
    }

    .brand-logo {
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }

    .brand-name {
        font-size: 18px;
        font-weight: 700;
        color: #1a1a1a;
        letter-spacing: 0.5px;
    }

    .nav-right {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .user-avatar {
        cursor: pointer;
    }

    .user-name {
        font-size: 14px;
        color: #333;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .nav-link {
        font-size: 14px;
        color: #666;
        text-decoration: none;
        cursor: pointer;
        transition: color 0.2s;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .nav-link:hover {
        color: #58a8e0;
    }

    .login-link {
        color: #58a8e0;
        font-weight: 500;
    }

    .logout-link:hover {
        color: #f56c6c;
    }

    .m-header >>> .el-divider--vertical {
        margin: 0 4px;
    }
</style>
